import { useCallback, useState } from 'react'
import type { SVGProps } from 'react'
import { Button } from 'blaze-ui/Button/Button'
import { REACT_APP_READER_URL } from 'env'
import { useQueryParams } from 'hooks/useQueryParams'
import { navigateToExternalUrl } from 'utils/location'
import Styles from './FacebookOAuthButton.module.scss'
import { IS_VM_REGISTRATION_KEY } from '../constants'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { Facebook } from 'blaze-ui/icons'

export const FacebookOAuthButton = ({
  workspaceInviteToken,
  checkNewUser = false,
}: {
  workspaceInviteToken: string
  checkNewUser?: boolean
}) => {
  const { isMobile } = useResponsiveDesign()
  const [isProcessing, setIsProcessing] = useState(false)
  const { domain, redirect_to, promotion_code, campaigns } = useQueryParams()

  const loginOrSignup = useCallback(async () => {
    localStorage.setItem(IS_VM_REGISTRATION_KEY, 'true')
    setIsProcessing(true)
    const state = {
      redirect_to,
      workspace_invite_token: workspaceInviteToken,
      domain,
      promotion_code,
      check_new_user: checkNewUser,
      campaigns,
    }

    const encodedState = btoa(JSON.stringify(state))
    const authUrl = `${REACT_APP_READER_URL}/omniauth/facebook?state=${encodedState}`

    if (window.top && window.top !== window) {
      window.top.location.href = authUrl
      return
    }

    navigateToExternalUrl(authUrl)
  }, [domain, redirect_to, workspaceInviteToken, promotion_code, checkNewUser, campaigns])

  return (
    <Button
      variant="secondary"
      size={isMobile ? 'md' : 'xl'}
      fullWidth
      frontIcon={(props: SVGProps<SVGSVGElement> & { size?: number }) => (
        <Facebook size={isMobile ? 24 : props.size} className={props.className} />
      )}
      useChildClass
      onPress={loginOrSignup}
      isDisabled={isProcessing}
      data-heap-id="continue-with-facebook"
    >
      <div className={Styles.facebookButton}>Continue with Facebook</div>
    </Button>
  )
}
